<template>
  <!-- POP UP -->
  <div>
    <div id="overlay" @click="closePopup()" style="position: fixed; width: 100%; height: 100%; top: 0; left: 0; right: 0; bottom: 0; background-color: rgba(0,0,0,0.5); z-index: 10; cursor: pointer;"></div>
    <div class="absolute flex flex-col bg-white shadow rounded-sm h-auto z-20 p-4" style="width: 380px; left: calc((108vw - 500px)/2); top:150px;z-index: 99;">
      <img @click="closePopup()" class="w-6 h-6 cursor-pointer flex absolute pin-r m-2 pin-t" src="../../../assets/close.png">
      <div class="flex flex-col justify-center mb-4 mx-4 mt-16 pt-10 bg-grey-lighter">
        <img class="flex self-center mt-10 absolute pin-t" src="../../../assets/enquire.svg" style="width:100px;">
          <textarea class="border border-solid border-grey-lightest p-1 py-2 rounded m-1 my-2 text-sm" name="" id="" cols="30" rows="6" v-model="text"></textarea>
          <div class="flex flex-row justify-center mb-4" style="">
              <div @click="sendEnquiry()" class="flex flex-col bg-blue px-6 py-2 justify-center cursor-pointer rounded-sm text-white text-sm hover:shadow-md">Send Enquiry</div>
          </div>
      </div>
      <div class="flex flex-col justify-center items-center p-1">
        <label class="flex align-center text-grey-darker text-xs" style="color:#ffb100">Note</label>
        <div class="flex text-grey-dark text-xs p-1 px-4 text-center">The patient will schedule a call consultation if his query is not answered</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  components: {
  },
  props: ['notification'],
  data () {
    return {
      text: `Hi ${this.notification.details.customer_name}, I noticed that you consulted with ${this.notification.details.doctor_name} on ${this.notification.details.date}. Is your health query answered?`
    }
  },
  computed: {
  },
  methods: {
    sendEnquiry: function () {
      this.$store.dispatch('notification/sendEnquiryToPatient', {id: this.notification.id, message: this.text})
      this.$emit('closePopup')
    },
    closePopup: function () {
      this.$emit('closePopup')
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/common/modals/EnquireNowCard.vue